module.exports = __webpack_public_path__ + "img/RWBuild-Workshop-Collage-Promo.0c6c077e.png";